// eslint-disable-next-line angular/factory-name
angular.
module("digiexam.gradingMatrix").
factory("GradingMatrixAbility", function gradingMatrixAbilityService() {
	"use strict";

	function GradingMatrixAbility(data) {
		var defaults = {
			id: 0,
			title: "",
		};

		angular.extend(this, defaults);

		if (data) {
			angular.extend(this, data);
		}
	}

	return GradingMatrixAbility;
});
